import React, { useState } from 'react'
import {  Divider, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { PieChart, Pie, Cell, Tooltip, Legend, TooltipProps, ResponsiveContainer } from "recharts";
import { getBranchesMetrics } from "../../Services/homePageService"
import { useEffectAsync } from '../../Hooks/useEffectAsync';
import { Box } from '@mui/system';
import PlaceIcon from '@mui/icons-material/Place';
import { BranchMetrics } from '../../@types/branch';
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';

const COLORS = ["#6AC700", "#005896", "#1c7b00", "#009ADC", '#82d4f6', "#b7e36b"];

function HomePage() {
    const [metrics, setMetrics] = useState<BranchMetrics>()
    const [pieData, setPieData] = useState<any>()

    const mapData = async () => {
        const payload = await getBranchesMetrics();
        if (payload) {
            setMetrics(payload)
           const piechart = await payload.branchHierachyStates.map(d => ({
                name: d.state,
                value: d.count
           })   
            )
           setPieData(piechart)
        }
    }

    useEffectAsync(async () => {
        await mapData()
    }, [])


    const CustomTooltip = ({ active, payload, label }: TooltipProps<ValueType, NameType>) => {
        if (active) {
            return (
                <div
                    className="custom-tooltip"
                    style={{
                        backgroundColor: "#ffff",
                        padding: "5px",
                        border: ".2px solid #cccc",
                        borderRadius: 10
                    }}  
                >
                    <p className="label">{<PlaceIcon color="primary"/>} {payload?.[0].name }</p>
                    <p className="desc">There are currenty {payload?.[0].value} branches in {payload?.[0].name}</p>
                </div>
            );
        }
        return null;
    };

    return (
        <div className="App">
            <div className="homePage-container">
                <Paper elevation={10}
                    className="homeMetrics"
                    sx={{ backgroundColor: "rgb(255,255,255, .8)" }}>
                    <Box sx={{ width: '100%', borderRadius: 1, display: 
                        'flex', flexDirection: 'column'}}>
                        <h1>Branches Distributions</h1>
                        <Divider sx={{
                            bgcolor: 'black',
                            mb: 6
                        }} />
                            <div style={{
                            width: '100%', borderRadius: 1, display: 'flex',
                            flexDirection: 'row', justifyContent: 'space-around'
                            }}>
                            <div>
                                <h3>States</h3>
                                <ResponsiveContainer className="pie" minWidth={300} width="100%" height="100%" maxHeight={400}>
                                    <PieChart width={200} height={600}>
                                      <Pie
                                            dataKey="value"
                                            isAnimationActive={false}
                                            data={pieData}
                                            cx="50%"
                                            cy="50%"    
                                        >
                                        { pieData && pieData.map((entry: any, index: number) => (
                                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                        ))}
                                      </Pie>
                                        <Tooltip content={<CustomTooltip />} />
                                        <Legend />
                                    </PieChart>
                                </ResponsiveContainer>
                            </div>
                            <div className="status">
                                <h3>Status</h3>
                                <TableContainer component={Paper} sx={{ minWidth: 30, mt: 7 }}>
                                    <Table  aria-label="simple table">
                                        <TableHead sx={{ bgcolor: "#009ADC", color: "white" }}>
                                            <TableRow>
                                                <TableCell sx={{ color: "white", fontWeight: 600, fontSize: "large" }} > STATUS </TableCell>
                                                <TableCell sx={{ color: "white", fontWeight: 600, fontSize: "large" }} > BRANCHES </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody> 
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell align="left">Open</TableCell>
                                                <TableCell component="th" scope="row" align="center">
                                                        {metrics?.openBranches}
                                                    </TableCell>
                                                    
                                                </TableRow>
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 }, bgcolor: "#e1f5fd" }}>
                                                <TableCell align="left">Pending Open</TableCell>
                                                <TableCell component="th" scope="row" align="center">
                                                    {metrics?.pendingOpenBranches}
                                                </TableCell>

                                            </TableRow>
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell align="left">Temporarily Closed</TableCell>
                                                <TableCell component="th" scope="row" align="center">
                                                    {metrics?.temporaryClosedBranches}
                                                </TableCell>

                                            </TableRow>
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 }, bgcolor: "#e1f5fd" }}>
                                                <TableCell align="left">Closed</TableCell>
                                                <TableCell component="th" scope="row" align="center">
                                                    {metrics?.permanentlyClosedBranches}
                                                </TableCell>
                                            </TableRow>
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 }, bgcolor: "#f3fbe6" }}>
                                                <TableCell align="left">Total Branches</TableCell>
                                                <TableCell component="th" scope="row" align="center">
                                                    {metrics && metrics?.openBranches + metrics?.pendingOpenBranches + metrics?.temporaryClosedBranches + metrics?.permanentlyClosedBranches}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                </div> 
                        </div>
                    </Box>
                </Paper>
            </div>
        </div>
    );
}

export default HomePage;
